import { render, staticRenderFns } from "./InformationPanelMain.vue?vue&type=template&id=1c6e736c&scoped=true&lang=pug&"
import script from "./InformationPanelMain.vue?vue&type=script&lang=ts&"
export * from "./InformationPanelMain.vue?vue&type=script&lang=ts&"
import style0 from "./InformationPanelMain.vue?vue&type=style&index=0&id=1c6e736c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6e736c",
  null
  
)

export default component.exports